import styled from 'styled-components'

export const Wrapper = styled.div`
    position: absolute;
    top: 2%;
    left: 2%;
    width: ${({ width }) => `${width || 3.5}vw`};
`

export const Icon = styled.img`
    width: 100%;
    height: 100%;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
`
